
export const logout = () => {
  window.location.href = '/auth-service/'
}
